import React, { forwardRef, useImperativeHandle,useRef,useEffect } from "react";
// import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useClientTypes } from "../../context/ClientTypeContext"; 

import { useMasterData } from "../../context/MasterDataContext";



const Comp_ClientTypes = forwardRef(({
    maxTags = undefined,
    // style = '',

    style={},   // container style
    tagStyle={},  // tags
    inputStyle={}, // input field


    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onClientTypeSelect,
    onClientTypeRemove,
    onClientTypeChangeTag,
}, ref) => {
    const placeHolder = "Select Company Type";
    // const {clienttype:masterClientTypes,ready:ClientTypeReady} = useClientTypes(); // Assuming this returns the list of property types

    const {clientTypes:masterClientTypes,clientTypesReady:ClientTypeReady}= useMasterData();
    

    const tagrefClientType = useRef(null);
    const hasInitialized = useRef(false);


/**
     * Resolve Client Type IDs or mixed tags into full colony objects from masterClienttype.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterClientTypes)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'clienttype' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterClientTypes.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(ctype => ({
          ...ctype,
          status: defaultStatus
        }));
      }



        useEffect(() => {
            if (
                !hasInitialized.current && 
                Array.isArray(defaultTags) &&
                defaultTags.length > 0 &&
                tagrefClientType.current &&
                ClientTypeReady &&
                Array.isArray(masterClientTypes) &&
                masterClientTypes.length > 0
                ) {
                tagrefClientType.current.setTags(defaultTags);
                hasInitialized.current = true;
                // console.log("✅ setTags called with:", defaultTags);
            }
            {
            const initialTags = getObjectFromIds(defaultTags);
            tagrefClientType.current.setTags(initialTags);
            hasInitialized.current = true;
        }
        }, [defaultTags?.length,masterClientTypes,ClientTypeReady]);


        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefClientType.current) {
        //         tagrefClientType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);




    // const [tags, setTags] = useState(defaultTags || []);

    // // Update tags when defaultTags changes
    // useEffect(() => {
    //     setTags(defaultTags || []);
    // }, [defaultTags]);

    // Debugging: Log defaultTags and masterUserTypes
    // useEffect(() => {
    //     // console.log("defaultTags in Comp_ClientTypes:", defaultTags);
    //     // console.log("masterClientTypes in Comp_ClientTypes:", masterClientTypes);
    // }, [defaultTags, masterClientTypes]);

    const handleSelectTag = (tag) => {
        if (onClientTypeSelect) {
            onClientTypeSelect(tag);
        }
    };

    const handleRemoveTag = (tag) => {
        if (onClientTypeRemove) {
            onClientTypeRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onClientTypeChangeTag) {
            onClientTypeChangeTag(AllTags);
        }
    };




    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getClientTypeTags: () => tagrefClientType.current.getTags(),
        // setClientTypeTags: (selected) => tagrefClientType.current.setTags(selected),
        getObjectFromIds,
        getClientTypeTags: () => selectedTags,
        setClientTypeTags: (tags) => setSelectedTags(tags),            
        getTagsbyIds: (ids) => getTags(ids)
    }));





    function getTags(ids) {
        if (ids.length > 0) {
            return masterClientTypes.filter(record => ids.includes(record.id));
        } else {
            return [];
        }
    }

    return (
        <div>
            <ComponentTagSelector
                ref={tagrefClientType}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterClientTypes} // Ensure this is populated
                defaultTags={defaultTags} // Use internal state for defaultTags
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
                maxTags={maxTags}
                displayKey="clienttype" // Ensure this matches the key in masterUserTypes
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag}
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
            {/* Render tags */}
            {/* {tags.map((tag) => (
                <span key={tag.id}>{tag.name}</span>
            ))} */}
        </div>
    );
});

export default Comp_ClientTypes;
